module.exports = __webpack_public_path__ + "img/card-dashboards-sources-update.b74cfa4e.svg";